import React from 'react';

import { BkLogoRevamp } from 'components/logo/bk-logo-revamp';
import { RpLogoRevamp } from 'components/logo/rp-logo-revamp';
import { useAuthContext } from 'state/auth';

export const Logo: React.FC = props => {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated ? <RpLogoRevamp {...props} /> : <BkLogoRevamp {...props} />;
};
